import React from 'react'

import * as S from './styles'
import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

export type FilterTagProps = {
  content: string
  disabled?: boolean
  onRemove?: () => void
}

export const FilterTag: React.FC<FilterTagProps> = ({
  content,
  disabled = false,
  onRemove
}) => {
  return (
    <S.TagContainer disabled={disabled}>
      <S.TagText>{content}</S.TagText>
      {onRemove && (
        <S.RemoveButton type="button" onClick={onRemove}>
          <Icon icon="close" color={theme.colors.neutral[700]} size="15" />
        </S.RemoveButton>
      )}
    </S.TagContainer>
  )
}
